// John Eldhose 20200622
import React, { Component } from 'react';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { LibraryBooks, Search } from '@material-ui/icons';
import { matchObjs } from '../../lib/lib';
import CourseList from './CourseList';

class Home extends Component {
  updateSearch = (obj) => {
    return (
      (typeof obj.search === 'undefined') ? { by: 'keyword' } : obj.search
    );
  }
  state = {
    text: '',
    search: this.updateSearch(this.props.parms)
  }
  componentDidUpdate(prevProps) {
    if(!matchObjs(prevProps.parms, this.props.parms, 'search'))
      this.setState({ search: this.updateSearch(this.props.parms) });
  }
  handleSearch = () => {
    this.setState({ search: { by: 'text', text: this.state.text, limit: 10 } });
  }
  content = () => {
    if(this.state.search.by === 'keyword')
      return (
        <div>
          <div style={{ padding: '10px' }}>
            <Typography variant='subheading' align='left'>
              Recommended Courses
            </Typography>
            <CourseList
              orientation='horizontal'
              search={{ by: 'team', exclude: [].concat(this.props.courses, this.props.learningpaths)}}
            />
          </div>
          <p />
          <div style={{ padding: '10px' }}>
            <Typography variant='subheading' align='left'>
              Latest Courses
            </Typography>
            <CourseList
              orientation='horizontal'
              search={{ by: 'date', date: 'Latest' }}
            />
          </div>
        </div>
      );
    else
      return (
        <div>
          <Typography variant='subheading' align='left'>
            Matching Contents
          </Typography>
          <CourseList
            orientation='vertical'
            search={this.state.search}
          />
        </div>
      );
  }

  render() {
    return (
      <div>
        <Grid container style={{ padding: '30px 0' }}>
          <Grid item md={2} />
          <Grid item sm={12} md={8}>
            <Grid container spacing={8} alignItems='flex-end'>
              <Grid item><LibraryBooks /></Grid>
              <Grid item xs>
                <TextField
                  required
                  fullWidth
                  label="Search Courses"
                  value={this.state.text}
                  onKeyPress={(e) => {if (e.key === 'Enter') {
                      this.handleSearch();
                      e.preventDefault();
                  }}}
                  onChange={(e) => this.setState({ text: e.target.value })}
                />
              </Grid>
              <Grid item>
                <Button
                  variant='raised'
                  color='primary'
                  onClick={this.handleSearch}
                >
                  <Search />
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={2} />
        </Grid>
        <p />
        {this.content()}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/academy/Home.js